import { passwordValidationSchema } from '../validationSchemas'
import rpmLogo from '../../../assets/rpm.svg'
import Icon from '../../../../common/components/Icon'
import { Formik } from 'formik'
import qs from 'qs'
import React from 'react'
import { useLocation } from 'react-router-dom'
import useConfirmPassword from '../hooks/useConfirmPassword'

export default function MobileConfirmPassword({ setStep }) {
    const location = useLocation()

    const { p } = qs.parse(location.search.replace('?', ''))
    let params = {}
    try {
        params = JSON.parse(atob(p))
    } catch {}

    if (!params.user || !params.email) return null

    let name = params.user.first_name.toLowerCase()
    name = name.charAt(0).toUpperCase() + name.slice(1)

    const email = params.email

    const { handleSubmit } = useConfirmPassword({
        email,
        isCoach: params.user.groups.includes('Coach'),
    })

    return (
        <div className="content">
            <img src={rpmLogo} alt="RPM Logo" id="rpm-logo" />
            <h1 className="title">Welcome, {name}</h1>
            <p className="subtitle">
                {/* TODO: THIS SHOULD BE THE NAME OF THE COACH */}
                You've been invited by Prime Meridian Health to join Noble.
            </p>
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: '',
                    termsAndConditions: false,
                }}
                validationSchema={passwordValidationSchema}
                onSubmit={(values, { setFieldError, setSubmitting }) => {
                    console.log(values)
                    setSubmitting(false)
                    handleSubmit(values, setFieldError)
                    setStep(2)
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                }) => (
                    <form onSubmit={handleSubmit} className="form">
                        <div className="inputs-wrapper">
                            <p className="form-title">Create Account</p>
                            <div className="input-wrapper">
                                <input
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    placeholder="Password"
                                    className="input"
                                />
                                <Icon
                                    name="lock"
                                    size={25}
                                    color="var(--primary-dark-green)"
                                    className="lock"
                                />
                            </div>

                            <p className="error-message">
                                {errors.password &&
                                    touched.password &&
                                    errors.password}
                            </p>

                            <div className="input-wrapper">
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.confirmPassword}
                                    placeholder="Confirm Password"
                                    className="input"
                                />
                                <Icon
                                    name="lock"
                                    size={25}
                                    color="var(--primary-dark-green)"
                                    className="lock"
                                />
                            </div>
                            <p className="error-message">
                                {errors.confirmPassword &&
                                    touched.confirmPassword &&
                                    errors.confirmPassword}
                            </p>
                        </div>

                        <ul className="password-requirements">
                            <p className="title">Your password must contain</p>
                            <li className="password-requirements__item">
                                <span className="password-requirements__item__icon">
                                    +
                                </span>
                                <p className="password-requirements__item__text">
                                    8 or more characters
                                </p>
                            </li>

                            <li className="password-requirements__item">
                                <span className="password-requirements__item__icon">
                                    +
                                </span>
                                <p className="password-requirements__item__text">
                                    uppercase letters
                                </p>
                            </li>
                            <li className="password-requirements__item">
                                <span className="password-requirements__item__icon">
                                    +
                                </span>
                                <p className="password-requirements__item__text">
                                    1 or more numbers/symbols
                                </p>
                            </li>
                            <li className="password-requirements__item">
                                <span className="password-requirements__item__icon">
                                    +
                                </span>
                                <p className="password-requirements__item__text">
                                    lowercase letters
                                </p>
                            </li>
                        </ul>

                        <div className="terms-and-conditions">
                            <div
                                role="button"
                                className="accept-terms"
                                onClick={() =>
                                    setFieldValue(
                                        'termsAndConditions',
                                        !values.termsAndConditions
                                    )
                                }
                            >
                                <Icon
                                    name="minimalist-check"
                                    active={values.termsAndConditions}
                                    color="#343434"
                                />
                            </div>

                            <div className="terms-and-conditions__text-wrapper">
                                <p
                                    className="terms-and-conditions__text-wrapper__text"
                                    onClick={() =>
                                        setFieldValue(
                                            'termsAndConditions',
                                            !values.termsAndConditions
                                        )
                                    }
                                    role="button"
                                >
                                    I have read and agree to the following:
                                </p>
                                <ul>
                                    <li>
                                        <a
                                            href="https://www.noble.health/privacy-policy"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Privacy Policy
                                        </a>{' '}
                                        {'&'}{' '}
                                        <a
                                            href="https://noble.health/terms-of-service/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Terms of Service
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {errors.termsAndConditions &&
                            touched.termsAndConditions && (
                                <p className="error-message">
                                    {errors.termsAndConditions}
                                </p>
                            )}

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="submit-button"
                        >
                            Create Account
                        </button>
                    </form>
                )}
            </Formik>
        </div>
    )
}
